<template>
  <div class="detail-material-sample">
    <div class="delivery-info">
      <div class="header-title">
        <div class="left-wrapper">
          <div class="blue-bar"></div>
          <div class="title-text">{{ $t('form.sampleDelivery') }}</div>
        </div>
      </div>
      <div class="sell-main-content">
        <div class="main-header">
          <div class="left-header">
            <span>{{ $t('form.totalUsed') }}：</span>
            <span class="total-num">{{ sampleListTotal }}</span>
          </div>
          <div class="sell-out-btn" @click="toSelectSample" v-if="!eventInfoObj.isDisable">+ {{ $t('button.select') }}</div>
        </div>
        <div class="promotion-item" v-for="subItem in sampleList" :key="subItem.protoId">
          <img v-if="subItem.imgUrl" class="icon-img" :src="subItem.imgUrl" alt="">
          <img v-else class="icon-img" src="@/assets/images/icon_noimg.png" alt="">
          <div class="info-item">
            <div class="product-name txt-ellipsis">{{ subItem.projectName }}·{{ subItem.productName }}</div>
            <div class="txt-ellipsis">{{ $t('form.inventory') }}：{{ subItem.inventoryCount }}</div>
          </div>
          <div class="stepper-custom">
            <div class="step-btn" @click="handleBtn(-5, subItem, 'sample')">-5</div>
            <div class="step-btn" @click="handleBtn(-1, subItem, 'sample')">-</div>
            <van-field class="step-value" v-model="subItem.putInCount" :disabled="eventInfoObj.isDisable" @focus="handleFocus(subItem.putInCount)" @blur="changeTotal(subItem, 'sample')" type="digit" :border="false" />
            <div class="step-btn" @click="handleBtn(1, subItem, 'sample')">+</div>
            <div class="step-btn" @click="handleBtn(5, subItem, 'sample')">+5</div>
          </div>
        </div>
      </div>
    </div>
    <div class="delivery-info">
      <div class="header-title">
        <div class="left-wrapper">
          <div class="blue-bar"></div>
          <div class="title-text">{{ $t('form.materialDelivery') }}</div>
        </div>
      </div>
      <div class="sell-main-content">
        <div class="main-header">
          <div class="left-header">
            <span>{{ $t('form.totalUsed') }}</span>
            <span class="total-num">{{ materialListTotal }}</span>
          </div>
          <div class="sell-out-btn" @click="toSelectMaterial" v-if="!eventInfoObj.isDisable">+ {{ $t('button.select') }}</div>
        </div>
        <div class="promotion-item" v-for="subItem in materialList" :key="subItem.materialId">
          <img v-if="subItem.imgUrl" class="icon-img" :src="subItem.imgUrl" alt="">
          <img v-else class="icon-img" src="@/assets/images/icon_noimg.png" alt="">
          <div class="info-item">
            <div class="product-info">
              <span class="product-name txt-ellipsis">{{ subItem.materielName }}</span>
              <van-icon v-if="subItem.isMain === 1" name="star" color="#e0bc38" />
            </div>
            <div class="material-inventory">
              <div class="product-name-item" v-if="subItem.materielType === 1">
                <div class="project-name universal-name">{{ subItem.projectName }}</div>
                <div class="inventory-num">{{ $t('form.inv') }}: {{ subItem.inventoryCount }}</div>
              </div>
              <div class="product-name-item" v-else>
                <div class="project-name" v-for="proItem in subItem.productName.split(',')" :key="proItem">{{ proItem }}</div>
                <div class="inventory-num">{{ $t('form.inv') }}: {{ subItem.inventoryCount }}</div>
              </div>
              <!-- <span class="project-name txt-ellipsis" :class="{'universal-name': subItem.materielType === 1}">{{ subItem.materielType === 1 ? 'Universal' : subItem.projectName }}</span>
              <span class="inventory-num txt-ellipsis">Inv：{{ subItem.inventoryCount }}</span> -->
            </div>
          </div>
          <div class="stepper-custom">
            <div class="step-btn" @click="handleBtn(-5, subItem, 'material')">-5</div>
            <div class="step-btn" @click="handleBtn(-1, subItem, 'material')">-</div>
            <van-field class="step-value" v-model="subItem.putInCount" :disabled="eventInfoObj.isDisable" @focus="handleFocus(subItem.putInCount)" @blur="changeTotal(subItem, 'material')" type="digit" :border="false" />
            <div class="step-btn" @click="handleBtn(1, subItem, 'material')">+</div>
            <div class="step-btn" @click="handleBtn(5, subItem, 'material')">+5</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant'
import { arsEventDeliveryInfoApi, arsEventUdateProtoDeliveryApi, arsEventUdateMaterialDeliveryApi } from '@/api/event'
export default {
  props: {
    eventId: {
      type: String,
      default: ''
    },
    eventInfoObj: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      materielCount: '',
      materialList: [],
      sampleList: [],
      oldPutInCountValue: 0
    }
  },
  computed: {
    materialListTotal () {
      return this.materialList.reduce((acc, curr) => acc + Number(curr.putInCount), 0)
    },
    sampleListTotal () {
      return this.sampleList.reduce((acc, curr) => acc + Number(curr.putInCount), 0)
    }
  },
  activated () {
    this.getDeliveryInfo()
  },
  created () {
    this.getDeliveryInfo()
  },
  methods: {
    toSelectMaterial () {
      this.$router.push(`/selectMaterial?policyId=${this.eventInfoObj.policyId}`)
    },
    toSelectSample () {
      this.$router.push('/shared/selectSample')
    },
    getDeliveryInfo () {
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      arsEventDeliveryInfoApi(this.eventId).then(res => {
        Toast.clear()
        this.materialList = res.data.materialList
        this.sampleList = res.data.protoList
      })
    },
    handleBtn (val, params, type) {
      if (this.eventInfoObj.isDisable) return
      const oldValue = Number(params.putInCount) || 0
      const newValue = oldValue + val
      this.updateDeliveryCount(params, type, newValue, oldValue)
    },
    handleFocus (value) {
      this.oldPutInCountValue = Number(value) || 0
    },
    changeTotal (params, type) {
      const oldValue = this.oldPutInCountValue
      const newValue = Number(params.putInCount) || 0
      this.updateDeliveryCount(params, type, newValue, oldValue)
    },
    updateDeliveryCount (params, type, newValue, oldValue) {
      if (newValue < 0) {
        newValue = 0
      }
      if (String(newValue).indexOf('.') > -1) {
        Toast(this.$t('tips.pleaseEnterAnInteger'))
        this.$set(params, 'putInCount', oldValue)
        return
      }
      const difference = newValue - oldValue
      const currentInventory = Number(params.inventoryCount) || 0
      this.$set(params, 'inventoryCount', currentInventory - difference)
      this.$set(params, 'putInCount', newValue)
      const requestApi = type === 'sample' ? arsEventUdateProtoDeliveryApi : arsEventUdateMaterialDeliveryApi
      const data = {
        eventId: this.eventId,
        putInCount: newValue,
        [type === 'sample' ? 'protoId' : 'materialId']: type === 'sample' ? params.protoId : params.materialId
      }
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      requestApi(data).then(res => {
        Toast.clear()
      })
    }
  }
}
</script>

<style lang="less" scoped>
.detail-material-sample {
  .header-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .left-wrapper {
      display: flex;
      align-items: center;
      .blue-bar {
        width: 5px;
        height: 16px;
        background-color: #307bff;
        margin-right: 5px;
      }
      .title-text {
        font-weight: bold;
        font-size: 13px;
        color: #333;
      }
    }
  }
  .delivery-info {
    margin-bottom: 20px;
    .sell-main-content {
      padding: 0 10px;
      .main-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px 0;
        border-top: 1px solid #e8effc;
        border-bottom: 2px solid #e8effc;
        font-size: 13px;
        .total-num {
          font-weight: bold;
          color: #307bff;
        }
        &:first-child {
          border-top: none;
        }
      }
      .promotion-item {
        display: flex;
        align-items: center;
        padding: 10px 6px;
        border-bottom: 1px solid #b9cbed;
        .icon-img {
          width: 40px;
          height: 40px;
          margin-right: 10px;
          object-fit: contain;
        }
        .info-item {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          height: 40px;
          .product-info {
            display: flex;
            align-items: center;
          }
          .product-name {
            max-width: 136px;
          }
          .material-inventory {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            .product-name-item {
              display: flex;
              align-items: center;
              flex-wrap: wrap;
            }
            .project-name {
              padding: 1px 3px;
              border: 1px solid #307bff;
              color: #307bff;
              margin-right: 3px;
              margin-bottom: 3px;
              font-size: 10px;
            }
            .universal-name {
              border: 1px solid #34b032;
              color: #34b032;
            }
            .inventory-num {
              flex: 1;
            }
          }
        }
        .stepper-custom {
          display: flex;
          align-items: center;
          border: 1px solid #b9cbed;
          border-radius: 4px;
          overflow: hidden;
          .step-btn {
            width: 28px;
            height: 24px;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: #fff;
            color: #323233;
            cursor: pointer;
            border-right: 1px solid #b9cbed;;
            font-size: 12px;
            &:last-child {
              border-right: none;
            }
            &:active {
              background-color: #f2f3f5;
            }
          }
          .step-value {
            width: 32px;
            height: 24px;
            padding: 0;
            background-color: #fff;
            border-right: 1px solid #b9cbed;
            border-radius: 0;
            /deep/ .van-field__control {
              text-align: center;
              height: 24px;
              line-height: 24px;
              color: #323233;
              font-size: 12px;
            }
          }
        }
      }
      .product-item {
        display: flex;
        align-items: center;
        padding: 10px 6px;
        border-bottom: 1px solid #e8effc;
        color: #000;
        .material-basc-info {
          display: flex;
          align-items: center;
          .icon-img {
            width: 40px;
            height: 40px;
            object-fit: contain;
          }
          .info-item {
            margin-left: 6px;
          }
          .title-txt {
            width: 90px;
            font-size: 12px;
            margin-bottom: 14px;
          }
          .subtitle-txt {
            display: flex;
            align-items: center;
            .product-type {
              padding: 0px 2px;
              border: 1px solid #307bff;
              color: #307bff;
              margin-right: 3px;
            }
          }
        }
        .sample-basc-info {
          width: 143px;
          font-size: 12px;
        }
        .sell-in-info {
          display: flex;
          justify-content: center;
          align-items: center;
          .plus-btn,
          .minus-btn {
            width: 23px;
            height: 24px;
            line-height: 24px;
            text-align: center;
            color: #323233;
            border: 1px solid #b9cbed;
            margin-right: 3px;
            font-size: 10px;
          }
          .input-field {
            width: 30px;
          }
          /deep/.van-cell {
            padding: 0;
            font-size: 12px;
            border: 1px solid #dce5f6;
            input {
              padding-left: 2px;
            }
          }
        }
      }
    }
  }
  .sell-out-btn {
    padding: 5px 3px;
    background-color: #e8effc;
    border-radius: 5px;
    font-size: 11px;
    border: 1px solid #307bff;
    color: #307bff;
    margin-right: 10px;
  }
}
</style>
